import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KpiDetailsDialogComponent } from 'src/app/components/main/employees/performance/my-metrics/kpi-details-dialog/kpi-details-dialog.component';
import {
  RegisteredWorkComplianceCategorySummary,
  RegisteredWorkComplianceWeek,
} from 'src/app/models/registered-work-compliance-kpi-data.model';

export interface RegisteredWorkComplianceWeeksDialogData {
  weeks: RegisteredWorkComplianceWeek[];
}

@Component({
  selector: 'app-registered-work-compliance-weeks-dialog',
  imports: [CommonModule, KpiDetailsDialogComponent],
  templateUrl: './registered-work-compliance-weeks-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './registered-work-compliance-weeks-dialog.component.css',
})
export class RegisteredWorkComplianceWeeksDialogComponent {
  readonly data = inject<RegisteredWorkComplianceWeeksDialogData>(MAT_DIALOG_DATA);

  readonly compliant_weeks_count = this.data.weeks.filter(week => week.is_compliant).length;
  readonly subtitle = `${this.compliant_weeks_count}/${this.data.weeks.length} semanas correctas`;

  categoryColor(category: RegisteredWorkComplianceCategorySummary): string {
    return category.is_in_range ? 'var(--green)' : 'var(--warn-color)';
  }

  weekColor(week: RegisteredWorkComplianceWeek): string {
    return week.is_compliant ? 'var(--green)' : 'var(--warn-color)';
  }
}
